import React, { useEffect } from "react";

import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { Loader } from "../../../../../components/Loader/Loader";
import { Download } from "lucide-react";
import {
  FondGroupwiseFan,
  FundGroupWise,
} from "../../../../../Redux/Slice/Fas/Financial Statement/Fund And Flow/FundAndFlow";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useTheme } from "../../../../../Themecontext/Themecontext";
import FASparentMultipalChild from "../../../../../components/Tables/FASparentMultipalChild";

export default function GroupWise({ accountGroup, month }) {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { FundGroupWisedata } = useSelector((state) => state.FundFlowSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");

  const YearId = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(FondGroupwiseFan());
    dispatch(
      FundGroupWise({
        Firm,
        Year: YearId,
        selectedIds: accountGroup.join(","),
        IdxMonthNames: month,
      }),
    );
  }, [dispatch, Firm, YearId, accountGroup, month]);
  const getCrDetailRows = FundGroupWisedata?.CrDetail?.map((item, index) => ({
    srNumber: index + 1,
    GroupMStName: item.GroupMStName,
    acname: item.acname,
    Receipt: item.Receipt,
  }));

  const getDrDetailRows = FundGroupWisedata?.DrDetail?.map((item, index) => ({
    srNumber: index + 1,
    GroupMStName: item.GroupMStName,
    acname: item.acname,
    Payment: item.Payment,
  }));

  const cardStyle = {
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
  };

  const headerStyle = {
    backgroundColor:
      isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour4,
    color: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
    padding: "14px",
  };

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const formatIndianAmount = (value) => {
      const num = Number(value || 0);

      return num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;

    /* ================= TITLE ================= */
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");
    doc.text("Fund Flow Statement (Groupwise)", pageWidth / 2, 15, {
      align: "center",
    });
    doc.line(marginX, 18, pageWidth - marginX, 18);

    const firm = DataMain?.Firm_Dtl?.[0] || {};
    doc.setFontSize(12);
    doc.setFont(undefined, "normal");
    doc.text(firm?.FirmName || "", pageWidth / 2, 25, { align: "center" });

    /* =====================================================
        1️⃣ RECEIPT DETAILS (CrDetail)
      ===================================================== */

    const firmName = DataMain?.Firm_List?.[0]?.GroupName || "";

    let startY = 26;

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");

    if (firmName) {
      doc.text(firmName, pageWidth / 2, startY, {
        align: "center",
      });
    }

    let yPos = 35;

    const receiptCols = [15, 80, 90, 45];
    const receiptWidth = receiptCols.reduce((a, b) => a + b, 0);
    const receiptLeft = (pageWidth - receiptWidth) / 2;

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text("RECEIPT DETAILS", pageWidth / 2, yPos, { align: "center" });
    yPos += 6;

    let sr = 1;
    const receiptRows =
      FundGroupWisedata?.CrDetail?.map((r) => [
        sr++,
        r.GroupMStName || "",
        r.acname || "",
        formatIndianAmount(r.Receipt),
      ]) || [];

    const receiptTotal = FundGroupWisedata?.CrDetail?.reduce(
      (sum, r) => sum + Number(r.Receipt || 0),
      0,
    );

    receiptRows.push(["", "", "TOTAL", formatIndianAmount(receiptTotal)]);

    autoTable(doc, {
      startY: yPos,
      margin: { left: receiptLeft },
      head: [["Sr", "Account Group Name", "Account Name", "Receipt Amount"]],
      body: receiptRows,
      theme: "grid",
      styles: {
        fontSize: 8,
        textColor: [0, 0, 0],
        fontStyle: "bold",
        lineColor: [210, 210, 210],
        lineWidth: 0.2,
        cellPadding: 2,
        valign: "middle",
        overflow: "linebreak",
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        fontSize: 9,
      },
      columnStyles: {
        0: { halign: "center", cellWidth: receiptCols[0] },
        1: { cellWidth: receiptCols[1] },
        2: { cellWidth: receiptCols[2] },
        3: { halign: "right", cellWidth: receiptCols[3] },
      },
      didParseCell(data) {
        if (data.row.raw?.[2] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [235, 235, 235];
        }
      },
    });

    /* =====================================================
        2️⃣ PAYMENT DETAILS (DrDetail)
      ===================================================== */
    doc.addPage();
    yPos = 30;

    const paymentCols = [15, 80, 90, 45];
    const paymentWidth = paymentCols.reduce((a, b) => a + b, 0);
    const paymentLeft = (pageWidth - paymentWidth) / 2;

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text("PAYMENT DETAILS", pageWidth / 2, yPos, { align: "center" });
    yPos += 6;

    sr = 1;
    const paymentRows =
      FundGroupWisedata?.DrDetail?.map((r) => [
        sr++,
        r.GroupMStName || "",
        r.acname || "",
        formatIndianAmount(r.Payment),
      ]) || [];

    const paymentTotal = FundGroupWisedata?.DrDetail?.reduce(
      (sum, r) => sum + Number(r.Payment || 0),
      0,
    );

    paymentRows.push(["", "", "TOTAL", formatIndianAmount(paymentTotal)]);

    autoTable(doc, {
      startY: yPos,
      margin: { left: paymentLeft },
      head: [["Sr", "Account Group Name", "Account Name", "Payment Amount"]],
      body: paymentRows,
      theme: "grid",
      styles: {
        fontSize: 8,
        textColor: [0, 0, 0],
        fontStyle: "bold",
        lineColor: [210, 210, 210],
        lineWidth: 0.2,
        cellPadding: 2,
        valign: "middle",
        overflow: "linebreak",
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
        fontSize: 9,
      },
      columnStyles: {
        0: { halign: "center", cellWidth: paymentCols[0] },
        1: { cellWidth: paymentCols[1] },
        2: { cellWidth: paymentCols[2] },
        3: { halign: "right", cellWidth: paymentCols[3] },
      },
      didParseCell(data) {
        if (data.row.raw?.[2] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [235, 235, 235];
        }
      },
    });

    /* ================= PAGE NUMBER ================= */
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.text(`Page ${i}`, marginX, pageHeight - 5);
    }

    doc.save("Fund_Flow_Groupwise.pdf");
  };
  if (FundGroupWisedata === "no" || FundGroupWisedata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }
  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <button
          onClick={handleDownload}
          className="common-hover-btn"
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6,
            color:
              isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour12,
            border: "none",
            padding: "10px 16px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
            fontWeight: "500",
            fontSize: "14px",
            height: "44px",
          }}
        >
          <Download size={16} />
          Download PDF
        </button>
      </div>
      <Row className="g-3">
        {/* LEFT SIDE */}
        <Col lg={12}>
          <div style={cardStyle}>
            <div style={headerStyle}>
              <h2
                style={{
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  fontWeight: "600",
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                }}
              >
                RECEIPT DETAIL
              </h2>
            </div>

            <FASparentMultipalChild
              data={getCrDetailRows}
              columns={[
                { label: "Sr. No.", key: "srNumber", align: "center" },
                {
                  label: " Account Group Name",
                  key: "GroupMStName",
                  align: "left",
                  colors: isdark === "light" ? "#000" : "#fff",
                },

                { label: "Count", key: "count", align: "center" },
                {
                  label: "Account Name",
                  key: "acname",
                  align: "left",
                  colors: isdark === "light" ? "#000" : "#fff",
                },
                {
                  label: "Receipt Amount",
                  key: "Receipt",
                  align: "right",
                  format: true,
                },
              ]}
              externalTotals={FundGroupWisedata?.CrSummary?.[0] || {}}
              singleChildParent={true}
            />
          </div>
        </Col>

        {/* RIGHT SIDE */}
        <Col lg={12}>
          <div style={cardStyle}>
            <div style={headerStyle}>
              <h2
                style={{
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  fontWeight: "600",
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                }}
              >
                PAYMENT DETAILS
              </h2>
            </div>

            <FASparentMultipalChild
              data={getDrDetailRows}
              columns={[
                { label: "Sr. No.", key: "srNumber", align: "center" },
                {
                  label: "Account Group Name",
                  key: "GroupMStName",
                  align: "left",
                  colors: isdark === "light" ? "#000" : "#fff",
                },
                { label: "Count", key: "count", align: "center" },
                {
                  label: "Account Name",
                  key: "acname",
                  align: "left",
                  colors: isdark === "light" ? "#000" : "#fff",
                },
                {
                  label: "Payment Amount",
                  key: "Payment",
                  align: "right",
                  format: true,
                },
              ]}
              externalTotals={FundGroupWisedata?.DrSummary?.[0] || {}}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}
